<button tabindex="-1" id="hidden" #hiddenElement class="position-absolute top-0 end-0 opacity-0"></button>
<div class="searchBarWrapper">
<ng-container *ngIf="searchDropdown ; else OtherCondition">
    <div class="ng-select-wrapper">
        <ng-select 
          class="searchDropdown" 
          [items]="dataList" 
          bindLabel="name" 
          bindValue="id" 
          [disabled]="optionDisable"
          [(ngModel)]="selectedId" 
          (ngModelChange)="inputValueEmit.emit($event)" 
          (search)="onSearchInput($event)"
          (focus)="isFocused = true" 
          (blur)="isFocused = false;isSearchValue= false"
          (open)="isDropdownActive = true" 
         (close)="isDropdownActive = false;serachvalue=''">
          
          <ng-template ng-notfound-tmp>
            <div class="lastOption">
              No records found. 
              <span [ngClass]="{'d-none':!newRecord}" class="text-secondary-color hand" (click)="addNewRecord.emit(serachvalue)">
                +Add New Record
              </span>
            </div>
          </ng-template>
        </ng-select>
        <label  class="label-transition" [class.active]="selectedId || isFocused || isSearchValue || isDropdownActive">{{ selectLabel || 'Select a Template'}}
          <i *ngIf="inputReqValidation" class="fst-normal ps-0 p-0 text-danger">*</i></label>
        <!-- Refresh/Clear Icon -->
        <span class="refresh-icon" *ngIf="(selectedId || isSearchValue || isDropdownActive) && !optionDisable" (click)="clearSelection()">
            <!-- <app-svg-icon
            class="svgIcon"
            [src]="'../../../../assets/SVGIcons/undoSVG.svg'"
          ></app-svg-icon> -->
          <app-svg iconType="UndoSVG" class="svgIcon">
            </app-svg>
        </span>
      </div>
      </ng-container>
<ng-template #OtherCondition>
    <ng-select class="ng-selectDropdown" [items]="dataList" 
    bindLabel="name" 
    bindValue="id" 
    [disabled]="optionDisable"
    [(ngModel)]="selectedId">
</ng-select>
</ng-template>
 </div>